import {
  PriceFreezeExpandedVoucherStateEnum,
  type PriceFreezeVoucherExpandedState,
} from "@b2bportal/core-types";
import {
  type PriceFreezeVoucher,
  type PriceFreezeOffer,
  StateEnum,
} from "@b2bportal/price-freeze-api";

const MILLISECONDS_IN_A_DAY = 86400000;

export const getPriceFreezeExpiryMs = (
  priceFreeze: PriceFreezeOffer | PriceFreezeVoucher
) => {
  if (priceFreeze.expiresAt != null) {
    return new Date(priceFreeze.expiresAt).getTime();
  }

  if ("createdAt" in priceFreeze) {
    return (
      new Date(priceFreeze.createdAt).getTime() +
      priceFreeze.serviceDetails.serviceDurationDays * MILLISECONDS_IN_A_DAY
    );
  }

  return (
    new Date(priceFreeze.purchasedAt).getTime() +
    priceFreeze.serviceDetails.serviceDurationDays * MILLISECONDS_IN_A_DAY
  );
};

export const getPriceFreezeExpiryDate = (
  priceFreeze: PriceFreezeOffer | PriceFreezeVoucher
) => {
  return new Date(getPriceFreezeExpiryMs(priceFreeze));
};

export const isPriceFreezeVoucherActive = (voucher: PriceFreezeVoucher) =>
  (voucher.voucherState.State === StateEnum.Valid ||
    voucher.voucherState.State === StateEnum.Pending) &&
  !isPriceFreezeVoucherExpired(voucher);

export const isPriceFreezeVoucherExpired = (voucher: PriceFreezeVoucher) =>
  voucher.voucherState.State === StateEnum.Valid &&
  Date.now() > getPriceFreezeExpiryMs(voucher);

export const isPriceFreezeVoucherInactive = (voucher: PriceFreezeVoucher) =>
  (voucher.voucherState.State !== StateEnum.Valid &&
    voucher.voucherState.State !== StateEnum.Cancelled) ||
  isPriceFreezeVoucherExpired(voucher);

export const getPriceFreezeExpandedVoucherState = (
  voucher: PriceFreezeVoucher
): PriceFreezeVoucherExpandedState => {
  if (voucher.voucherState.State === StateEnum.Valid) {
    return isPriceFreezeVoucherActive(voucher)
      ? PriceFreezeExpandedVoucherStateEnum.Active
      : PriceFreezeExpandedVoucherStateEnum.Expired;
  }

  return voucher.voucherState.State;
};
